import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LogoHeader from '../Assets/Image/group of namkeen labour contractor logo.png';
import '../Assets/WebsiteCss/webheader.css';
import { MdMarkEmailRead } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";

function WebHeader() {
    const location = useLocation();
    const [expanded, setExpanded] = useState(false); // Add state

    const handleNavClick = () => {
        setExpanded(false); // Collapse navbar on link click
    };

    return (
        <>
            {/* Top Contact Navbar */}
            <div className="top-header"
                style={{
                    backgroundColor: '#23326A',
                    color: 'white',
                    padding: '8px 0',
                    fontSize: '14px',
                    textAlign: 'center',
                    width: '100%',
                    position: 'fixed',
                    top: 0,
                    zIndex: 1060,
                    transition: 'all 0.3s ease-in-out'
                }}>

                <Container className="d-flex justify-content-between align-items-center">
                    <div className="contact-info">
                        <a
                            href="mailto:info@nsnamkeenlabourcontractor.com"
                            style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                        >
                            <MdMarkEmailRead />
                            <span>info@nsnamkeenlabourcontractor.com</span>
                        </a>

                        <span className='mx-2'>|</span>

                        <a
                            href="https://wa.me/919660815610"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <span><FaPhoneSquareAlt />9602910275</span>
                        </a>
                    </div>
                </Container>
            </div>

            {/* Main Navbar */}
            <Navbar expand="lg" className="custom-navbar fixed-top" expanded={expanded}>
                <Container>
                    <Navbar.Brand as={NavLink} to="/">
                        <img src={LogoHeader} alt="Logo" className="navbar-logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mx-auto">
                            <Nav.Link as={NavLink} to="/" exact onClick={handleNavClick}>Home</Nav.Link>
                            <Nav.Link as={NavLink} to="/aboutus" exact onClick={handleNavClick}>About Us</Nav.Link>
                            <Nav.Link as={NavLink} to="/services" exact onClick={handleNavClick}>Services</Nav.Link>
                            <Nav.Link as={NavLink} to="/ourproducts" exact onClick={handleNavClick}>Products</Nav.Link>
                            <Nav.Link as={NavLink} to="/teamandachivements" exact onClick={handleNavClick}>Our Achievements</Nav.Link>
                            <Nav.Link as={NavLink} to="/contact" exact onClick={handleNavClick}>Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default WebHeader;